<template>
	<div class="card asset drop-down-hover">
		<img v-if="in_progress" class="center-me" src="/images/loading-color.svg">

		<template v-else>		
			<div v-if="asset.can.update || asset.can.delete" class="drop-down dropleft w-100 pt-2 pr-3 text-right" style="">
				<a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					<i class="far fa-ellipsis-h text-xl text-white"></i>
				</a>
				<div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
					<a href="#" class="dropdown-item" data-toggle="modal" data-target="#assetViewModal" @click="viewDetails()">View Details</a>
					<span v-if="asset.can.update" class="dropdown-item" @click="startEditing()">Edit Asset</span>
					<span v-if="asset.can.delete" class="dropdown-item" @click="deleteAsset()">Delete</span>
				</div>
			</div>

			<div v-if="editing" class="editing card">

				<file-field
					class="card-img-top"
					:default_url="asset.thumbnail_url"
					ref="file"	
					@file_changed="changedFile($event)"
				/>
				<div class="card-body">					
				<form
					@submit.prevent="submitForm"
					@keydown="form.onKeydown($event)"
					@change="form.onKeydown($event)">	

					<alert-errors :form="form" class="text-sm">There were some problems with your input.</alert-errors>

					<div class="form-group">
						<label class="mb-0">Asset Name</label>
						<input type="text" class="form-control" v-model="form.name">
					</div>

				    <div class="form-group">
					    <label class="mb-0">Asset Type <span class="text-gray-500"> - Optional</span></label>
	                    <v-select
							multiple
							label="label"
							:options="asset_types"
							:reduce="label => label.id"
							v-model="form.asset_types"
	                    />
				    </div>

				    <div class="form-group">
					    <label class="mb-0">Service Lines <span class="text-gray-500"> - Optional</span></label>
	                    <v-select
	                        multiple
	                        label="label"
	                        :options="options.service_lines"
	                        :reduce="label => label.id"
	                        v-model="form.service_lines"
	                    />
				    </div>

				    <div class="form-group">
					    <label class="mb-0">Specialties <span class="text-gray-500"> - Optional</span></label>
	                    <v-select
	                        multiple
	                        label="label"
	                        :options="options.specialties"
	                        :reduce="label => label.id"
	                        v-model="form.specialties"
	                    />
				    </div>

					<div class="text-right w-100">
						<span class="btn btn-sm btn-ghost-secondary" @click="stopEditing()">Cancel</span>
						<span class="btn btn-sm btn-primary" @click="submitForm()">Save Asset</span>
					</div>			    
				</form>
			</div>
			</div>

			<div class="bg-gray-300">
				<img class="card-img-top thumb" :src="asset.thumbnail_url" alt="Thumbnail">
			</div>

			<div class="card-body">
				<strong >{{ asset.name }}</strong> <br>
				<span v-for="specialty in asset.specialties" class="badge bg-teal-200 text-teal-700 mr-1">{{ specialty.label }}</span>
				<span v-for="service_line in asset.service_lines" class="badge bg-orange-100 text-orange-700 mr-1">{{ service_line.label }}</span>
			</div>

			<div v-if="asset.asset_types.length" class="card-footer text-gray-500 text-sm">
				{{ Array.prototype.map.call(asset.asset_types, function(item) { return item.label; }).join(', ') }}
			</div>

		</template>

	</div>
</template>

<script>

	import { mapState } from 'vuex';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';
	import { objectToFormData } from 'object-to-formdata'

	export default {
		props: ['asset', 'asset_types'],

		components: {
			HasError,
			AlertError,
			AlertErrors,
			AlertSuccess,
			Form,
		},

		data() {
			return {
				editing: false,
				form: {},
				in_progress: false,
			}
		},

		methods: {
			changedFile($event) {
				this.form.file = this.$refs.file.file;
			},

			deleteAsset() {
				this.$emit('delete_asset', this.asset.id);
			},

			startEditing() {
				this.editing = true;
				this.form = new Form({
					name: this.asset.name,
					asset_types: this.asset.asset_types.map(type => type.id),
					service_lines: this.asset.service_lines.map(line => line.id),
					specialties: this.asset.specialties.map(spec => spec.id),
				});
			},

			stopEditing() {
				this.form = {};
				this.editing = false;
			},

			submitForm() {
				this.in_progress = true;
				this.form.submit('post', '/api/assets/' + this.asset.id, {
					transformRequest: [function (data, headers) {
						data['_method'] = 'PUT';
						return objectToFormData(data)
					}],
				}).then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'Asset updated',
					});						
					
					this.in_progress = false;
					this.$emit('asset_updated', data);
					this.stopEditing();
				});
			},

			viewDetails() {
				this.$emit('view_details', this.asset.id);
			}
		},

		computed: {
			...mapState(['options'])
		},
	}

</script>

<style>
	x.filezone { margin-top:0 !important; }
</style>